import React, { useEffect, useState } from "react";
import {
  Panel,
  MTable,
  Container,
  PaginationTable,
  SelectDropDown,
  InternalServerError,
  Pagination,
} from "../../../../Components";
import { Grid, MenuItem, TextField, Typography } from "@material-ui/core";
import { useIntl } from "react-intl";
import { Outlet, useParams } from "react-router-dom";
import UserSevicesApi from "../../../../Redux/Actions/UserAction";
import CustomerServicesApi from "../../../../Redux/Actions/CustomerAction";
import { useDispatch, useSelector } from "react-redux";
import { PersonAdd } from "@material-ui/icons";
import { LanguageProps, RoleProps } from "../../../../Components/Field";
import { useStyles } from "./User.styles";
import { MTableToolbar } from "@material-table/core";
import { useSnackbar } from "notistack";
export const UserList = () => {
  const { userList, apiToken, currentUser, updatedUser, allCustomers } =
    useSelector((state: any) => ({
      userList: state?.UserReducer?.userList,
      apiToken: state?.UserReducer?.apiToken,
      currentUser: state?.UserReducer?.currentUser,
      updatedUser: state?.UserReducer?.updatedUser,
      allCustomers: state?.CustomerReducer?.allCustomers,
    }));
  const { formatMessage } = useIntl();
  const tableRef = React.createRef();
  const dispatch: any = useDispatch();
  const [reloadPage, setReload] = useState(false);
  let [selected, setSelected] = useState<any>(20);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const { create } = useParams();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
  try {

    dispatch(UserSevicesApi.UserListData(currentUser?.customerId, apiToken, enqueueSnackbar));
  } catch (error) {
    console.error(error);
  }
  }, [])
  interface ICompanyUser {
    id: number;
    name: string;
    email: string;
    isDeleted: boolean;
    role: any;
    status: any;
    lastName: string;
    firstName: string;
    language: any;
    customerId: any;
    editable: boolean;
  }
  const activation = (user: ICompanyUser) => ({
    tooltip:
      user?.isDeleted == true
        ? formatMessage({ id: "component.mtable.activateTooltip" })
        : formatMessage({ id: "component.mtable.inactivateTooltip" }),
    icon: user?.isDeleted == true ? "check" : "block",
    disabled:
      user?.status != "Active" || currentUser?.id == user?.id ? true : false,
    onClick: async () => {
      setReload(true);
      dispatch(UserSevicesApi?.deleteUser(user?.id, apiToken, enqueueSnackbar));
      setTimeout(() => {
        dispatch(
          UserSevicesApi?.UserListData(
            currentUser?.customerId,
            apiToken,
            enqueueSnackbar
          )
        );
        setReload(false);
      }, 1500);
    },
  });
  const resendInvitation = (user: ICompanyUser) => {
    return {
      tooltip: formatMessage({
        id: "organization.users.table.action.resendInvite",
      }),
      icon: "send",
      disabled:
        user?.status != "Active" && currentUser.role == "ClientAdmin"
          ? false
          : true,
      onClick: () => {
        let param = {
          email: user?.email,
          firstName: user?.firstName,
          lastName: user?.lastName,
          language: LanguageProps[user?.language],
          roleId: RoleProps[user?.role],
          sentBy: currentUser?.id,
          customerId: user?.customerId,
        };
        setReload(true);
        dispatch(
          CustomerServicesApi.sendClientAdminInvitation(
            param,
            apiToken,
            enqueueSnackbar
          )
        );
        setTimeout(() => {
          dispatch(
            UserSevicesApi.UserListData(
              currentUser?.customerId,
              apiToken,
              enqueueSnackbar
            )
          );
          setReload(false);
        }, 1500);
      },
    };
  };
  const bodydata: any = [
    {
      title: formatMessage({
        id: "customer.table.companyName",
        defaultMessage: "Company name",
      }),
      field: "companyName",
      editable: () => {
        return false;
      },
    },
    {
      title: formatMessage({
        id: "customer.create.firstName",
        defaultMessage: "First name",
      }),
      field: "firstName",
    },
    {
      title: formatMessage({
        id: "customer.create.lastName",
        defaultMessage: "Last name",
      }),
      field: "lastName",
    },
    {
      title: formatMessage({
        id: "users.table.email",
        defaultMessage: "Email",
      }),
      field: "email",
      editable: () => {
        return false;
      },
    },
    {
      title: formatMessage({ id: "users.table.role", defaultMessage: "Role" }),
      field: "role",
      lookup: {
        Admin: formatMessage({
          id: "form.roll.Admin",
          defaultMessage: "Admin",
        }),
        ClientAdmin: formatMessage({
          id: "form.roll.clientAdmin",
          defaultMessage: "ClientAdmin",
        }),
        User: formatMessage({ id: "form.user", defaultMessage: "User" }),
      },
      editable: (row: any, rowData: any) => {
        return rowData.id == currentUser?.id ? false : true;
      },
      editComponent: (props: any) => {
        const editLookup = {
          "ClientAdmin": formatMessage({ id: "form.roll.clientAdmin", defaultMessage: "ClientAdmin" }),
          "User": formatMessage({ id: "form.user", defaultMessage: "User" })
        };
    
        return (
          <TextField
            select
            value={props.value || ""}
            className='role-select'
            onChange={(e) => props.onChange(e.target.value)}
            variant="outlined" 
            SelectProps={{
              MenuProps: {
                anchorOrigin: {
                  vertical: "bottom", 
                  horizontal: "left"
                },
                transformOrigin: {
                  vertical: "top", 
                  horizontal: "left"
                },
                getContentAnchorEl: null
              }
            }}
          >
            {Object.entries(editLookup).map(([key, label]) => (
              <MenuItem key={key} value={key}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        );
      }
    },
    {
      title: formatMessage({
        id: "users.table.status",
        defaultMessage: "Status",
      }),
      field: "status",
      lookup: {
        Active: formatMessage({
          id: "status.active",
          defaultMessage: "Active",
        }),
        Pending: formatMessage({
          id: "status.pending",
          defaultMessage: "Pending",
        }),
        Expired: formatMessage({
          id: "status.expire",
          defaultMessage: "Expired",
        }),
      },
      editable: () => {
        return false;
      },
    },
  ];
  const onhandleChange = (event: any) => {
    setSelected(event?.target?.value);
    let customerId = event?.target?.value;
    dispatch(
      UserSevicesApi.UserListData(customerId, apiToken, enqueueSnackbar)
    );
  };
  const { pagination, toolbar, body, header } = Pagination();
  return (
    <div className="userList-page-conatiner">
      <Container fullWidth>
        {create === "create" ? (
          <Outlet />
        ) : (
          <Panel
            titleKey="organization.users"
            titleValues={"button"}
            buttonTitle={"add.user"}
            pathLink={"/ms/administrations/create-users"}
            role={currentUser?.role}
            icon={<PersonAdd />}
          >
            <MTable
              tableRef={tableRef}
              columns={bodydata}
              data={userList?.length == undefined ? [] : userList}
              actions={[activation, resendInvitation]}
              isLoading={reloadPage}
              onPageChange={(page) => setPage(page)}
              onRowsPerPageChange={(pageSize: any) =>
                setRowsPerPage(parseInt(pageSize, 10))
              }
              localization={{ pagination, toolbar, body, header }}
              editable={{
                isEditable: (rowdata) =>
                  rowdata?.status != "Active" ? false : true,
                onRowUpdate: (newData) =>
                  new Promise((resolve) => {
                    const userData = {
                      email: newData?.email,
                      firstName: newData?.firstName,
                      lastName: newData?.lastName,
                      role: newData?.role,
                    };
                    setReload(true);
                    dispatch(
                      UserSevicesApi.userUpdate(
                        newData?.id,
                        userData,
                        apiToken,
                        enqueueSnackbar
                      )
                    );
                    setTimeout(() => {
                      dispatch(
                        UserSevicesApi.UserListData(
                          currentUser?.customerId,
                          apiToken,
                          enqueueSnackbar
                        )
                      );
                      setReload(false);
                      resolve(updatedUser);
                    }, 2000);
                  }),
              }}
              components={{
                Pagination: (props: any) => (
                  <Grid component="td" container justifyContent="center">
                    <Grid item xs={4}>
                      <Typography className={classes.total}>
                        {formatMessage({ id: "component.mtable.total" })}
                        &nbsp;{userList?.length}
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <PaginationTable
                        props={props}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        count={userList}
                      />
                    </Grid>
                  </Grid>
                ),
                Toolbar: (props) => (
                  <Grid container justifyContent="flex-end">
                    {currentUser?.role === "Admin" && (
                      <>
                        <Grid item className={classes.label}>
                          <label>
                            {formatMessage({
                              id: "customer.sort.by",
                              defaultMessage: "Sort by Customer",
                            })}{" "}
                            &nbsp;&nbsp;
                          </label>
                        </Grid>
                        <Grid item xs={3} style={{ paddingTop: 15 }}>
                          <SelectDropDown
                            handleChange={onhandleChange}
                            id="id"
                            OptionsValueId={
                              allCustomers == undefined ? [] : allCustomers
                            }
                            fieldName={"client"}
                            selected={selected}
                            ClassName={classes.select}
                          />
                        </Grid>
                      </>
                    )}
                    <Grid item>
                      <MTableToolbar {...props} />
                    </Grid>
                  </Grid>
                ),
              }}
            />
          </Panel>
        )}
      </Container>
    </div>
  );
};
